import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Logo from "../../assets/logotipo-ifeira.svg";
import loc from "../../assets/localização.png";
import locRoxo from "../../assets/localização_roxo.png";
import LoginProvider from "../../providers/LoginProvider";
import { login } from "../../services/Auth";

import "./styles.css";

class Login extends Component {
  state = {
    email: "",
    password: "",
    error: "",
    ativo: false,
    emailFocado: false,
    senhaFocado: false,
    verSenha: false,
  };
  handleLogin = async (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ error: "Preencha e-mail e senha para continuar!" });
    } else {
      try {
        const LProvider = new LoginProvider();
        const response = await LProvider.login(email, password);
        await login(response.data.token, response.data.usuario);
        if (response.data.usuario.tipo === "entregador_master") {
          this.props.history.push("/app/entregadores");
        } else {
          this.props.history.push("/app/principal");
        }
      } catch (err) {
        this.setState({
          error: "Houve um problema com o login, verifique suas credenciais",
        });
      }
    }
  };
  verSenha = () => {
    let input = document.getElementsByTagName("input")[1];
    let inputImg = document.getElementsByTagName("img")[1];
    if (this.state.verSenha) {
      input.setAttribute("type", "password");
      inputImg.src = loc;
      this.setState({ verSenha: false });
    } else {
      input.setAttribute("type", "text");
      inputImg.src = locRoxo;
      this.setState({ verSenha: true });
    }
  };
  render() {
    return (
      <div className={"container-flex"}>
        <form className={"form"} onSubmit={this.handleLogin}>
          <img src={Logo} alt="Ifeira logo" style={{ margin: 0, marginTop: 50 }} />
          <h2
            style={{
              color: "#717A8C",
              marginBottom: 50,
              marginTop: 30,
              fontSize: 18,
            }}
          >
            MÓDULO ADMIN
          </h2>
          {this.state.error && (
            <p style={{ paddingLeft: 35, color: "red" }}>{this.state.error}</p>
          )}
          {this.state.emailFocado ? (
            <p
              style={{
                color: "#701B8C",
                margin: 0,
                paddingLeft: 35,
                fontSize: 14,
                fontWeight: 900,
              }}
            >
              Email
            </p>
          ) : (
            <p style={{ height: 20, margin: 0 }}></p>
          )}

          <input
            onFocus={() => {
              this.setState({ emailFocado: true });
            }}
            onBlur={() => {
              this.setState({ emailFocado: false });
            }}
            type="email"
            placeholder="E-mail"
            onChange={(e) => this.setState({ email: e.target.value })}
          />
          {this.state.senhaFocado ? (
            <p
              style={{
                color: "#701B8C",
                margin: 0,
                paddingLeft: 35,
                fontSize: 14,
                fontWeight: 900,
              }}
            >
              Senha
            </p>
          ) : (
            <p style={{ height: 20, margin: 0 }}></p>
          )}

          <div>
            <input
              onFocus={() => {
                this.setState({ senhaFocado: true });
              }}
              onBlur={() => {
                this.setState({ senhaFocado: false });
              }}
              type="password"
              placeholder="Senha"
              onChange={(e) => this.setState({ password: e.target.value })}
            />
            <i style={{ marginLeft: -20, position: "relative", top: 5 }}>
              <buttton style={{ position: "relative" }} onClick={() => this.verSenha()}>
                <img
                  alt={"visibilidade"}
                  src={loc}
                  style={{
                    width: 20,
                    margin: 0,
                    cursor: "pointer",
                    position: "relative",
                    top: -2,
                  }}
                ></img>
              </buttton>
            </i>
          </div>

          <div style={{ padding: 0, paddingLeft: 34, paddingRight: 34 }}>
            {this.state.email !== "" && this.state.password !== "" ? (
              <button type="submit" className="ativo">
                ENTRAR
              </button>
            ) : (
              <button type="submit">ENTRAR</button>
            )}
          </div>
          <p style={{ fontSize: 12, textAlign: "center" }}>
            Ao continuar, você concorda com os <span>Termos & Condições</span>
          </p>
        </form>
      </div>
    );
  }
}
//<i style={{marginLeft:-25}}><img src={loc} style={{width:20,margin:0,marginTop:20}}></img></i>
export default withRouter(Login);
